<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
  class="dark bg-gray-900 print:hidden"
  [appearance]="navigationAppearance"
  [mode]="isScreenSmall ? 'over' : 'side'"
  [name]="'mainNavigation'"
  [navigation]="navigation?.default || []"
  [opened]="!isScreenSmall"
>
  <!-- Navigation header hook -->
  <ng-container fuseVerticalNavigationContentHeader>
    <!-- Logo -->
    <div class="h-25 my-10 flex items-center justify-center">
      <img class="w-15" src="assets/images/logo/agritrack-icon.png" alt="Logo image" />
    </div>
  </ng-container>
</fuse-vertical-navigation>

<!-- TradeX live import status panel — layout level keeps it above CDK overlay dialogs -->
<app-tradex-import-status-panel></app-tradex-import-status-panel>

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
  <!-- Header -->
  <div class="bg-card relative z-49 flex h-16 w-full flex-0 items-center px-4 shadow dark:border-b dark:bg-transparent dark:shadow-none print:hidden md:px-6">
    <div class="flex items-center space-x-2 pr-2">
      <!-- Navigation toggle button -->
      <button mat-icon-button aria-label="Toggle main navigation" (click)="toggleNavigation('mainNavigation')">
        <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
      </button>
      <!-- Navigation appearance toggle button -->
      <button class="hidden md:inline-flex" mat-icon-button aria-label="Toggle navigation appearance" (click)="toggleNavigationAppearance()">
        <mat-icon [svgIcon]="'heroicons_outline:arrows-right-left'"></mat-icon>
      </button>
    </div>
    @if (contextTitle) {
      <div
        class="pointer-events-none absolute left-1/2 hidden max-w-[35%] -translate-x-1/2 items-center gap-3 sm:flex"
        [attr.title]="contextTitle"
        aria-live="polite"
      >
        <span
          class="h-px w-7 shrink-0 bg-slate-300 dark:bg-slate-600"
          [style.background-color]="topBarBranding?.accentColor || null"
          aria-hidden="true"
        ></span>
        <div class="flex min-w-0 items-center gap-2.5">
          @if (topBarBranding?.logoUrl) {
            <img class="h-7 w-auto max-w-24 object-contain" [src]="topBarBranding?.logoUrl" [alt]="contextTitle + ' logo'" />
            <span class="h-5 w-px bg-slate-200 dark:bg-slate-700" aria-hidden="true"></span>
          }
          <span class="truncate text-lg font-semibold tracking-wide text-slate-800 dark:text-slate-100">
            {{ contextTitle }}
          </span>
        </div>
        <span
          class="h-px w-7 shrink-0 bg-slate-300 dark:bg-slate-600"
          [style.background-color]="topBarBranding?.accentColor || null"
          aria-hidden="true"
        ></span>
      </div>
    }
    <!-- Components -->
    <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
      <button
        mat-icon-button
        [attr.aria-label]="'GENERAL.COMPANY_SELECTION' | transloco"
        matTooltip="{{ 'GENERAL.COMPANY_SELECTION' | transloco }}"
        (click)="goToCompanySelection()"
      >
        <mat-icon>business</mat-icon>
      </button>

      <app-theme-toggle></app-theme-toggle>
      <languages></languages>
      <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
      <search [appearance]="'bar'"></search>
      <user></user>
    </div>
  </div>

  <!-- Content -->
  <div class="flex flex-auto flex-col items-center">
    <div class="flex w-full justify-center">
      @if (true) {
        <router-outlet></router-outlet>
      }
    </div>
  </div>

  <!-- Footer -->
  <div class="bg-card relative z-49 flex h-14 w-full flex-0 items-center justify-start border-t px-4 dark:bg-transparent print:hidden md:px-6">
    <span class="text-secondary font-medium">Agritrack &copy; {{ currentYear }}</span>
  </div>
</div>
